export const juneUppercase = "imx5l";
export default {juneUppercase};